import { FeatureFlag, Organization, Podcast, PodcastEpisodeListType, PodcastListType } from '@nimey/podcast-global-entity';
import { withCurrentOrg } from '../../hoc/with-current-org';
import  { Fragment, useEffect } from 'react';
import { usePodcastList } from '@/modules/backend/hooks/use-podcast-list';
import { PodcastProvider, useLocalPodcast } from '@/modules/global/components/podcast/podcast-provider';
import { PodcastTitle } from '@/modules/global/components/podcast/title';
import { LoadMore } from '@/modules/layout/components/load-more';
import styles from './podcsat-list.module.scss';
import { usePodcastEpisodeList } from '@/modules/backend/hooks/use-podcast-episode-list';
import { Link } from 'react-router-dom';
import { Button } from '@nimey/react-ui';
import { useHostingPodcastList } from '@/modules/backend/hooks/use-hosting-podcast-list';
import { DetailLink, HostingPodcastProvider, Status, Title } from '@/modules/global/components/podcast/hosting-podcast-provider';
import { FlexRow } from '@/modules/layout/components/grid/flex-row';
import { FeatureGuard } from '@/modules/backend/components/feature-guard';

const PodcastRendererWithPodcast = ({podcast, org}: {podcast: Podcast, org: Organization}) => {
  const { meta, loadMore } = usePodcastEpisodeList({podcastId: podcast.id}, PodcastEpisodeListType.RECENT);
  useEffect(() => {
    loadMore();
  }, [])
  return (
    <Link to={`/manager/${org.id}/podcast/${podcast.id}`} className={styles.podcast}>
      <div className={[styles.flex, styles['space-between']].join(' ')}>
        <div className={styles.title}><PodcastTitle /></div>
      </div>
      <div className={[styles.flex, styles['space-between']].join(' ')}>
        <div>{meta?.totalCount} Episoden</div>
        <div>Letzte Episode: {podcast.latestEpisode ? `${(new Date(podcast.latestEpisode)).toLocaleDateString()} ${(new Date(podcast.latestEpisode)).toLocaleTimeString()}` : 'N/A'}</div>
      </div>
    </Link>
  );
}

const PodcastRenderer = ({org}: {org: Organization}) => {
  const { podcast } = useLocalPodcast();

  if(podcast) return <PodcastRendererWithPodcast {...{podcast, org}} />

  return <></>
}

const Hosting = (props: {org: Organization}) => {
  const { org } = props;
  const { allIds, hasMore, loadMore } = useHostingPodcastList(org.id);

  return (
    <Fragment>
      {!allIds || allIds.length === 0 ? (
        <p>Diese Organisation verwaltet noch keine Podcasts</p>
      ) : ''}
      <ul className={styles['podcast-list']}>
        {allIds.map(id => (
          <li key={id} className={`${styles['list-entry']} ${styles.card}`}>
            <HostingPodcastProvider orgId={org.id} podcastId={id}>
              <DetailLink>
                <FlexRow style={{justifyContent: 'space-between'}}>
                  <strong><Title /></strong>
                  <Status />
                </FlexRow>
              </DetailLink>
            </HostingPodcastProvider>
          </li>
        ))}
        <LoadMore {...{hasMore, loadMore}} />
      </ul>
    </Fragment>
  );
}

const Listing = (props: {org: Organization}) => {
  const { org } = props;
  const { allIds, hasMore, loadMore } = usePodcastList({orgId: org.id}, PodcastListType.ALL);

  return (
    <Fragment>
      {!allIds || allIds.length === 0 ? (
        <p>Diese Organisation verwaltet noch keine Podcasts</p>
      ) : ''}
      <ul className={styles['podcast-list']}>
        {allIds.map(id => (
          <li key={id} className={`${styles['list-entry']} ${styles.card}`}>
            <PodcastProvider podcastId={id}>
              <PodcastRenderer {...{org}} />
            </PodcastProvider>
          </li>
        ))}
        <LoadMore {...{hasMore, loadMore}} />
      </ul>
    </Fragment>
  );
}

const OrgPodcastListWithOrg = (props: {org: Organization}) => {
  const { org } = props;

  return (
    <Fragment>
      <Link to={`/manager/${org.id}/add`}><Button>Neuen Podcast hinzufügen</Button></Link>
      <FeatureGuard flag={FeatureFlag.MANAGER_HOSTING}>
        <h2>Gehostete Podcasts</h2>
        <Hosting {...props} />
      </FeatureGuard>
      <h2>Gelistete Podcasts</h2>
      <Listing {...props} />
      
      
    </Fragment>
  );
}

export const OrgPodcastList = withCurrentOrg<{}>(OrgPodcastListWithOrg);